import { Grid, Card, Text } from "@shopify/polaris";
import styles from "../../styles/components/Cards/card.module.css";

const InfoCard = ({ label, value, columnSpan }) => {
  return (
    <Grid.Cell columnSpan={columnSpan}>
      <Card className={styles.card}>
        <Text as="p" variant="bodyMd">
          {label}
        </Text>
        <Text variant="headingXl" as="h3">
          {value}
        </Text>
      </Card>
    </Grid.Cell>
  );
};

export default InfoCard;
